import { translate } from "app/filters/i18nFilter";
import { MAX_NAME_LENGTH, MIN_NAME_LENGTH } from "app/pages/activation/components/RankWidget/config";
import { modalsTexts } from "app/pages/activation/components/RankWidget/texts";

export const nameValidation = (name: string, existingNames: string[]): string | null => {
    let error: string | null = null;
    const existingCampaignsLowerCase = existingNames.map((campaignName) => campaignName.toLowerCase());

    if (name.length < MIN_NAME_LENGTH) {
        error = translate(modalsTexts.nameInputMinError, { min: MIN_NAME_LENGTH });
    }

    if (existingCampaignsLowerCase.includes(name.toLowerCase())) {
        error = translate(modalsTexts.nameInputExistsError);
    }

    if (name.length > MAX_NAME_LENGTH) {
        error = translate(modalsTexts.nameInputMaxLengthError, { max: MAX_NAME_LENGTH });
    }

    return error;
};
